import { Box } from '@hivebrite/design-system/Box';

import { useHydrateCustomAttributes } from 'hb-react/frontoffice/apps/Mentoring/components/SharedCard/hooks';
import { type SharedCardProfile } from 'hb-react/frontoffice/apps/Mentoring/types';
import {
  type MenteesCustomizableAttributes,
  type MentorsCustomizableAttributes,
} from 'hb-react/frontoffice/apps/MyMentoring/utils/types';

import CustomAttributes from './CustomAttributes';
import Location from './Location';
import Skills from './Skills';
import UserPresentation from './UserPresentation';

interface CardBodyProps {
  customAttributes:
    | MenteesCustomizableAttributes
    | MentorsCustomizableAttributes;
  isLocationDisplayed: boolean;
  isSkillsDisplayed: boolean;
  profile: SharedCardProfile;
  withStatusLabel?: boolean;
}

const CardBody = ({
  profile,
  customAttributes: programCustomAttributes,
  withStatusLabel = false,
  isSkillsDisplayed,
  isLocationDisplayed,
}: CardBodyProps) => {
  const {
    location,
    skills,
    custom_attributes_card: profileCustomAttributes,
  } = profile;

  const customAttributes = useHydrateCustomAttributes(
    programCustomAttributes,
    profileCustomAttributes,
  );

  return (
    <Box flexDirection="column" flexGrow={1}>
      <UserPresentation profile={profile} withStatusLabel={withStatusLabel} />
      {isLocationDisplayed && <Location location={location} />}
      {isSkillsDisplayed && <Skills skills={skills} />}
      {customAttributes && (
        <CustomAttributes customAttributes={customAttributes} />
      )}
    </Box>
  );
};

export default CardBody;
